import React, { useRef } from 'react';
import { COMPANY_NAME } from '../constants';
import emailjs from '@emailjs/browser';

const ContactUs = () => {
  const form = useRef();

const sendEmail = (e) => {
  e.preventDefault();

  const formEl = form.current;
  const userName = formEl.user_name.value?.trim();
  const userEmail = formEl.user_email.value?.trim();
  const userMessage = formEl.message.value?.trim();

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  // ✅ Basic validation
  if (!userName || !userEmail || !userMessage) {
    alert('Please fill in all fields.');
    return;
  }

  if (!emailRegex.test(userEmail)) {
    alert('Please enter a valid email address.');
    return;
  }

  // ✅ Step 1: Send confirmation to the customer
  emailjs.send(
    'service_18rmxug',
    'template_customer_notify',
    {
      to_name: userName,
      to_email: userEmail,
      name: COMPANY_NAME, // used as {{name}} in template
    },
    '4NfOvMmOcT1KJYcAs'
  )
  .then((customerResult) => {
    console.log('Customer confirmation sent:', customerResult.text);

    // ✅ Step 2: Notify the admin
    return emailjs.send(
      'service_18rmxug',
      'template_admin_notify',
      {
        user_name: userName,
        user_email: userEmail,
        message: userMessage
      },
      '4NfOvMmOcT1KJYcAs'
    );
  })
  .then((adminResult) => {
    console.log('Admin notification sent:', adminResult.text);
    alert('Your message has been sent successfully!');
    formEl.reset();
  })
  .catch((error) => {
    console.error('Email sending error:', error);
    alert('Failed to send your message. Please try again later.');
  });
};



  return (
    <div className="max-w-6xl mx-auto p-6 bg-white rounded shadow-md flex flex-col md:flex-row items-center md:items-start gap-6">
      <div className="md:w-1/2">
        <h2 className="text-3xl font-bold mb-4 text-gray-900">Contact {COMPANY_NAME}</h2>
        <form
          ref={form}
          onSubmit={sendEmail}
          className="space-y-4"
        >
          <div>
            <label className="block mb-1 font-semibold text-gray-700" htmlFor="name">Name:</label>
            <input
              type="text"
              name="user_name"
              id="name"
              required
              className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-yellow-400"
            />
          </div>
          <div>
            <label className="block mb-1 font-semibold text-gray-700" htmlFor="email">Email:</label>
            <input
              type="email"
              name="user_email"
              id="email"
              required
              className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-yellow-400"
            />
          </div>
          <div>
            <label className="block mb-1 font-semibold text-gray-700" htmlFor="message">Message:</label>
            <textarea
              name="message"
              id="message"
              rows="5"
              required
              className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-yellow-400"
            ></textarea>
          </div>
          <button
            type="submit"
            className="bg-yellow-400 hover:bg-yellow-500 text-gray-900 font-bold py-2 px-6 rounded shadow-lg transition duration-300"
          >
            Submit
          </button>
        </form>
        <div className="mt-6 text-gray-700">
          <p>Email: nsteratechnologies@gmail.com</p>
        </div>
      </div>
      <div className="md:w-1/2">
        <img
          src="https://images.unsplash.com/photo-1525182008055-f88b95ff7980?auto=format&fit=crop&w=800&q=80"
          alt="Contact Support"
          className="rounded shadow-md w-full h-auto object-cover"
        />
      </div>
    </div>
  );
};

export default ContactUs;
